import React, { useEffect, useState } from "react";
import "./DepositsDetails.scss";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import { formatISO, endOfDay } from "date-fns";
import webSocketService from "../../services/WebSocketService";
import StatisticTable from "../../components/StatisticTable/StatisticTable";
import useTableContent from "./hooks/useTableContent";
import { MoonLoader } from "react-spinners";
import { loaderOverride } from "../../utils/constants/constants";
import DepositDetailsLegend from "../../components/DepositDetailsLegend/DepositDetailsLegend";
import DepositDetailsItem from "../../components/DepositDetailsItem/DepositDetailsItem";
import Footer from "../../components/Footer/Footer";
import parseDate from "../../utils/parseDate";

const DepositsDetails = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { totalTable, USDTable, BTCTable } = useTableContent(data);
  const navigate = useNavigate();
  const location = useLocation();

  const { date } = location.state || {};

  const dateSplitted = date.split("-");
  const dateObj = new Date(
    dateSplitted[0],
    +dateSplitted[1] - 1,
    dateSplitted[2],
  );

  const endOfDayObj = endOfDay(dateObj);

  const getDepositsData = async () => {
    let body = {
      type: "deposits",
      from: formatISO(new Date(dateObj)).slice(0, 19) + "Z",
      to: formatISO(new Date(endOfDayObj)).slice(0, 19) + "Z",
      groupBy: "user",
      currencies: ["USD", "BTC"],
    };

    const depositsData = await webSocketService.sendMessage(
      "getStatistic",
      "c",
      body,
    );

    if (typeof totals === "string") {
      setData([]);
    } else {
      setData(depositsData);
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  useEffect(() => {
    getDepositsData();
  }, []);

  if (isLoading) {
    return (
      <div className="deposit-details__loader">
        <MoonLoader
          color="#7236CD"
          loading={isLoading}
          cssOverride={loaderOverride}
          size={35}
        />
      </div>
    );
  }
  return (
    <div className="deposit-details__wrapper">
      <div className="deposit-details__content">
        <Header withLogo navigate={navigate} />
        <div className="deposit-details__top-block">
          <span className="deposit-details__label">{parseDate(date)}</span>
        </div>
        <div className="deposit-details__tables">
          <StatisticTable data={totalTable} />
          <StatisticTable data={USDTable} />
          <StatisticTable data={BTCTable} />
        </div>

        <div className="deposit__items-table">
          <DepositDetailsLegend />
          {data?.grouped
            ? Object.entries(data?.grouped)?.map((el) => (
                <DepositDetailsItem el={el} key={el[0]} />
              ))
            : null}
        </div>
      </div>
      <Footer navigate={navigate} />
    </div>
  );
};

export default DepositsDetails;
